var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 107,
    viewBox: "0 0 106 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_5154)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86 0.608887H20C8.95431 0.608887 0 9.56319 0 20.6089V86.6089C0 97.6546 8.9543 106.609 20 106.609H86C97.0457 106.609 106 97.6546 106 86.6089V20.6089C106 9.56319 97.0457 0.608887 86 0.608887Z",
    fill: "url(#paint0_linear_29_5154)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_29_5154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4632 54.7369C34.4947 54.7369 36.9579 52.2737 36.9579 49.2422C36.9579 48.358 36.7684 47.6001 36.3895 46.8422L42.5158 41.8527C43.4632 42.5474 44.6 42.9895 45.8632 42.9895C47.1263 42.9895 48.2632 42.5474 49.2105 41.8527L55.3368 46.8422C54.9579 47.5369 54.7684 48.358 54.7684 49.2422C54.7684 52.2737 57.2316 54.7369 60.2632 54.7369C63.2947 54.7369 65.7579 52.2737 65.7579 49.2422C65.7579 48.358 65.5684 47.6001 65.1895 46.8422L71.3158 41.8527C72.2632 42.5474 73.4 42.9895 74.6632 42.9895C77.6947 42.9895 80.1579 40.5264 80.1579 37.4948C80.1579 34.4632 77.6947 32.0001 74.6632 32.0001C71.6316 32.0001 69.1684 34.4632 69.1684 37.4948C69.1684 38.379 69.3579 39.1369 69.7368 39.8948L63.6105 44.8843C62.6632 44.1895 61.5263 43.7474 60.2632 43.7474C59 43.7474 57.8632 44.1895 56.9158 44.8843L50.7263 39.958C51.1053 39.2632 51.2947 38.4422 51.2947 37.558C51.2947 34.5264 48.8316 32.0632 45.8 32.0632C42.7684 32.0632 40.3053 34.5264 40.3053 37.558C40.3053 38.4422 40.4947 39.2001 40.8737 39.958L34.7474 44.9474C33.8 44.2527 32.6632 43.8106 31.4 43.8106C28.3684 43.8106 25.9053 46.2737 25.9053 49.3053C25.9053 52.3369 28.4316 54.7369 31.4632 54.7369ZM74.5368 34.5895C76.1789 34.5895 77.5053 35.9159 77.5053 37.558C77.5053 39.2001 76.1789 40.5895 74.5368 40.5895C72.8947 40.5895 71.5684 39.2632 71.5684 37.6211C71.5684 35.979 72.8947 34.5895 74.5368 34.5895ZM60.2 46.2737C61.8421 46.2737 63.1684 47.6001 63.1684 49.2422C63.1684 50.8843 61.8421 52.2106 60.2 52.2106C58.5579 52.2106 57.2316 50.8843 57.2316 49.2422C57.2316 47.6632 58.5579 46.2737 60.2 46.2737ZM45.8 34.5895C47.4421 34.5895 48.7684 35.9159 48.7684 37.558C48.7684 39.2001 47.4421 40.5895 45.8 40.5895C44.1579 40.5895 42.8316 39.2632 42.8316 37.6211C42.8316 35.979 44.1579 34.5895 45.8 34.5895ZM31.4632 46.2737C33.1053 46.2737 34.4316 47.6001 34.4316 49.2422C34.4316 50.8843 33.1053 52.2106 31.4632 52.2106C29.8211 52.2106 28.4947 50.8843 28.4947 49.2422C28.4947 47.6632 29.8211 46.2737 31.4632 46.2737Z",
    fill: "url(#paint1_linear_29_5154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7368 71.8527H79.5895V48.8001C79.5895 48.1053 79.021 47.5369 78.3263 47.5369H70.7474C70.0526 47.5369 69.4842 48.1053 69.4842 48.8001V71.8527H65.1895V60.4843C65.1895 59.7895 64.6211 59.2211 63.9263 59.2211H56.3474C55.6526 59.2211 55.0842 59.7895 55.0842 60.4843V71.8527H50.7895V48.8001C50.7895 48.1053 50.2211 47.5369 49.5263 47.5369H41.9474C41.2526 47.5369 40.6842 48.1053 40.6842 48.8001V71.8527H36.3895V60.4843C36.3895 59.7895 35.8211 59.2211 35.1263 59.2211H27.5474C26.8526 59.2211 26.2842 59.7895 26.2842 60.4843V71.8527H24.2632C23.5684 71.8527 23 72.4211 23 73.1159C23 73.8106 23.5684 74.379 24.2632 74.379H81.7368C82.4316 74.379 83 73.8106 83 73.1159C83 72.4211 82.4316 71.8527 81.7368 71.8527ZM72.0105 50.0632H77.0632V71.8527H72.0105V50.0632ZM57.6737 61.7474H62.7263V71.8527H57.6737V61.7474ZM43.2737 50.0632H48.3263V71.8527H43.2737V50.0632ZM28.9368 61.7474H33.9895V71.8527H28.9368V61.7474Z",
    fill: "url(#paint2_linear_29_5154)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_5154",
    x1: 13.2474,
    y1: 0.608895,
    x2: 15.4832,
    y2: 106.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A27BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_5154",
    x1: 25.28,
    y1: 42.1286,
    x2: 72.0512,
    y2: 81.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9577FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347169,
    stopColor: "#CACCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3A3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29_5154",
    x1: 25.28,
    y1: 42.1286,
    x2: 72.0512,
    y2: 81.4964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9577FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347169,
    stopColor: "#CACCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3A3FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_5154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    fill: "white",
    transform: "translate(0 0.608887)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_29_5154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 43,
    fill: "white",
    transform: "translate(23 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF2);
export default __webpack_public_path__ + "static/media/f2.155cc131369b6369e014969190513c00.svg";
export { ForwardRef as ReactComponent };